// =====================
// Infinite Scroll
// =====================
// class InfiniteScroll extends HTMLElement {
//   constructor() {
//     super();
//     this.anchor = this.querySelector("a");
//     if (!this.anchor) return;

//     this.button = document.createElement("button");
//     this.button.textContent = "Load More";
//     this.button.className = "btn btn--primary";
//     this.button.style.cssText = "margin: 20px auto; padding: 12px 40px; cursor: pointer; display: block;";

//     this.insertBefore(this.button, this.anchor);

//     this.triggeredByLoadMore = false;
//     this.button.addEventListener("click", () => this.loadNextPage());
//   }

//   async loadNextPage() {
//     if (!this.anchor) return;

//     this.button.disabled = true;
//     this.button.textContent = "Loading...";
//     this.triggeredByLoadMore = true;

//     const url = this.anchor.getAttribute("href");
//     if (!url) return;

//     try {
//       const response = await fetch(url);
//       const text = await response.text();
//       const html = new DOMParser().parseFromString(text, "text/html");

//       const newGrid = html.querySelector("[data-product-grid]");
//       const grid = document.querySelector("[data-product-grid]");

//       if (newGrid && grid) {
//         Array.from(newGrid.children).forEach((child) => grid.appendChild(child));

//         if (window.lazySizes) window.lazySizes.init();
//         document.dispatchEvent(new CustomEvent('shopify:section:load'));
//       }

//       const newInfinite = html.querySelector("infinite-scroll");
//       if (newInfinite) {
//         this.replaceWith(newInfinite);
//       } else {
//         this.button.disabled = true;
//         this.button.textContent = "No more products";
//       }
//     } catch (err) {
//       console.error("Load More error:", err);
//       this.button.disabled = false;
//       this.button.textContent = "Load More";
//     } finally {
//       this.triggeredByLoadMore = false;
//     }
//   }
// }

// customElements.define("infinite-scroll", InfiniteScroll);
function initGridSwatchImages(context = document) {
  const products = context.querySelectorAll('.grid-product');

  products.forEach((product) => {
    const swatches = product.querySelectorAll(
      '.color-swatch[data-variant-id][data-variant-image]'
    );
    const imageDivs = product.querySelectorAll(
      '.grid-product__color-image'
    );

    if (!swatches.length || !imageDivs.length) return;

    // 🔹 STEP 1: Inject background images
    swatches.forEach((swatch) => {
      const variantId = swatch.dataset.variantId;
      const imageUrl = swatch.dataset.variantImage;

      if (!variantId || !imageUrl) return;

      const imgDiv = product.querySelector(
        `.grid-product__color-image--${variantId}`
      );

      if (imgDiv && !imgDiv.dataset.bgInit) {
        imgDiv.style.backgroundImage = `url(${imageUrl})`;
        imgDiv.dataset.bgInit = 'true';
      }
    });

    // 🔹 STEP 2: Bind hover switching
    swatches.forEach((swatch) => {
      if (swatch.dataset.hoverBound) return;
      swatch.dataset.hoverBound = 'true';

      const variantId = swatch.dataset.variantId;
      const targetImg = product.querySelector(
        `.grid-product__color-image--${variantId}`
      );

      if (!targetImg) return;

      swatch.addEventListener('mouseenter', () => {
        imageDivs.forEach(img => img.classList.remove('is-active'));
        targetImg.classList.add('is-active');
      });

      swatch.addEventListener('mouseleave', () => {
        imageDivs.forEach(img => img.classList.remove('is-active'));
      });
    });
  });
}


class InfiniteScroll extends HTMLElement {
  // constructor() {
  //   super();

  //   this.anchor = this.querySelector("a");
  //   this.loader = this.querySelector(".infinite-loader");
  //   if (!this.anchor) return;

  //   this.loading = false;

  //   this.observer = new IntersectionObserver(
  //     (entries) => {
  //       if (entries[0].isIntersecting && !this.loading) {
  //         this.loadNextPage();
  //       }
  //     },
  //     { rootMargin: "200px" } // preload before bottom
  //   );

  //   this.observer.observe(this);
  // }
   constructor() {
    super();

    const grid = document.querySelector('[data-product-grid]');
    if (!grid || grid.children.length === 0) {
      this.remove();
      return;
    }

    this.anchor = this.querySelector("a");
    this.loader = this.querySelector(".infinite-loader");
    if (!this.anchor) {
      this.remove();
      return;
    }

    this.loading = false;

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loading) {
          this.loadNextPage();
        }
      },
      { rootMargin: "200px" }
    );

    this.observer.observe(this);
  }

  async loadNextPage() {
    if (!this.anchor || this.loading) return;

    this.loading = true;
    this.loader.hidden = false;

    const url = this.anchor.getAttribute("href");
    if (!url) return;

    try {
      const res = await fetch(url);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, "text/html");

      const newGrid = html.querySelector("[data-product-grid]");
      const grid = document.querySelector("[data-product-grid]");

      if (newGrid && grid) {
        [...newGrid.children].forEach((item) => grid.appendChild(item));
 // 🔥 merged swatch + image init
  initGridSwatchImages(grid);
        if (window.lazySizes) window.lazySizes.init();
        document.dispatchEvent(new CustomEvent("shopify:section:load"));
      }
      else {
  this.observer.disconnect();
  this.remove();
  return;
}
if (!document.querySelector('[data-product-grid]')?.children.length) {
  this.loader.hidden = true;
}

      const newInfinite = html.querySelector("infinite-scroll");

      if (newInfinite && newInfinite.querySelector("a")) {
        this.anchor.href = newInfinite.querySelector("a").href;
      } else {
        this.observer.disconnect();
        this.remove();
      }

    } catch (e) {
      console.error("Infinite scroll error:", e);
    } finally {
      this.loading = false;
      this.loader.hidden = true;
    }
  }


}

customElements.define("infinite-scroll", InfiniteScroll);

// =====================
// Product Count
// =====================
let totalProductCount = null;

async function calculateTotalCount() {

  document.querySelector('[data-total-count]').textContent = `Loading...`;  

  let countEl = document.querySelector('.product-total-count');
//   if (!countEl) return;

//   countEl.textContent = 'Loading products…';

  let page = 1;
  let total = 0;
  let hasNext = true;

  const baseUrl = window.location.pathname;
  const currentParams = new URLSearchParams(window.location.search);

  while (hasNext) {
    currentParams.set('page', page);

    const res = await fetch(`${baseUrl}?${currentParams.toString()}`);
    const text = await res.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');

    const items = doc.querySelectorAll('[data-product-grid] .grid__item');
    total += items.length;

    hasNext = doc.querySelector('infinite-scroll a');
    page++;
  }

  totalProductCount = total;
  console.log("totalProductCount",totalProductCount)
  // if(totalProductCount){
  //   console.log("gettherrr")
  //     document.querySelector('[data-total-count]').textContent = `${totalProductCount} product${totalProductCount !== 1 ? 's' : ''}`;
  // }
  if (totalProductCount === 0) {
  document.querySelector('[data-total-count]').textContent = 'No products found';
} else {
  document.querySelector('[data-total-count]').textContent =
    `${totalProductCount} product${totalProductCount !== 1 ? 's' : ''}`;
}

}

// =======================
// Initial count
// =======================
// calculateTotalCount();

// =======================
// Recalculate when filters apply (AJAX detection)
// =======================

// 1️⃣ Listen to Shopify collection filter events
let lastUrl = removeSortParam(location.href);

function removeSortParam(url) {
  const u = new URL(url);
  u.searchParams.delete('sort_by');
  return u.toString();
}

// new MutationObserver(() => {
//   const currentUrl = removeSortParam(location.href);

//   if (currentUrl !== lastUrl) {
//     lastUrl = currentUrl;
//     // calculateTotalCount();
//   }
// }).observe(document, { subtree: true, childList: true });


// 2️⃣ Shopify section reload (ignore Load More)
// document.addEventListener('shopify:section:load', function() {
//   const infiniteEl = document.querySelector('infinite-scroll');
//   if (infiniteEl && infiniteEl.triggeredByLoadMore) return;
//   totalProductCount = null;
//   setTimeout(calculateTotalCount, 100);
// });

document.addEventListener('DOMContentLoaded', () => {
  initGridSwatchImages();
});


